import Link, { LinkNoPrefetch } from '@/components/Link'
import { UiMenu, Weblinkext } from '@/kontent/content-types'
import { Mapping } from '@/types'
import {
	Elements,
	IContentItem,
	IContentItemsContainer,
} from '@kontent-ai/delivery-sdk'
import { getLinkedItems, getUrlFromMapping, isNavItemExternalUrl } from '.'
import { isWebLinkext } from './type_predicates'

export const getLinkFromLinkUI = (
	navItem: IContentItem,
	mappings: Mapping[],
	linkedItems: IContentItemsContainer,
	preview = false,
) => {
	if (!linkedItems) {
		// console.error('utils/index.ts line 158 - Need to implement getLinkFromLinkUI with linkedItems')
		return {
			url: '',
			target: '',
			rel: undefined,
			linkComponent: 'a',
			isExternal: false,
		}
	}

	const isExternal = isNavItemExternalUrl(navItem)
	if (isExternal) {
		const _navItem = navItem as Weblinkext
		return {
			url: _navItem.elements.link_url.value || '',
			target: isExternal ? '_blank' : undefined,
			rel: isExternal ? 'nofollow noopener' : undefined,
			linkComponent: isExternal ? 'a' : Link,
			isExternal,
		}
	}

	let _navItemCodename = navItem?.system.codename
	if (navItem?.system.type === 'ui_menu') {
		const _navItem = navItem as UiMenu
		const _navItemItem = getLinkedItems(
			_navItem.elements.item,
			linkedItems,
		)?.[0]

		// FIX: If linked item is not loaded, use the item reference codename directly
		// This handles cases where the referenced page is not in linkedItems (e.g., sibling pages)
		_navItemCodename =
			_navItemItem?.system.codename || _navItem.elements.item.value[0]

		if (_navItemItem && isWebLinkext(_navItemItem)) {
			return {
				url: _navItemItem.elements.link_url.value || '',
				target: '_blank',
				rel: 'nofollow noopener',
				linkComponent: 'a',
				isExternal: true,
			}
		}
	} else if (
		navItem?.system.type === 'weblinkint' ||
		navItem?.system.type === 'link_resource_file' ||
		navItem?.system.type === 'web_link_syllabus'
	) {
		// All three types follow the same pattern: an `item` modular_content
		// field referencing a target with a URL slug in mappings.
		// FIX: If the linked target item isn't loaded (e.g. data builder uses
		// linkedItemsReferenceHandler: 'ignore'), fall back to the item
		// reference codename directly. Mirrors the ui_menu branch above.
		const _navItem = navItem as IContentItem<{
			item: Elements.LinkedItemsElement<IContentItem>
		}>
		_navItemCodename =
			getLinkedItems(_navItem.elements.item, linkedItems)?.[0]?.system
				?.codename || _navItem.elements.item.value?.[0]
	}

	const internalLink = preview ? LinkNoPrefetch : Link

	return {
		url: getUrlFromMapping(mappings, _navItemCodename) || '',
		target: isExternal ? '_blank' : undefined,
		rel: isExternal ? 'nofollow noopener' : undefined,
		linkComponent: isExternal ? 'a' : internalLink,
		isExternal,
	}
}
